import {
  en_perkspotTranslations,
  en_defaultTranslations,
} from "@hopper-b2b/i18n";
import { TranslationLanguage } from "@hopper-b2b/types";
import { merge } from "lodash-es";

/** Some configurations don't need a review from translations team
 * If you want to override any of them, add them as an attribute in this object
 */
const translation = {
  [TranslationLanguage.en]: merge(
    en_defaultTranslations,
    en_perkspotTranslations
  ),
};

export default translation;
